import { render, staticRenderFns } from "./xcbl.vue?vue&type=template&id=1c6facaa&scoped=true&"
import script from "./xcbl.vue?vue&type=script&lang=js&"
export * from "./xcbl.vue?vue&type=script&lang=js&"
import style0 from "./xcbl.vue?vue&type=style&index=0&id=1c6facaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6facaa",
  null
  
)

export default component.exports